import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class HotelPolicyI18nCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	public base = createFeatureIslandCategoryStore({
		title: "基本設定",
		description: "",
		isBasicSetup: true,
	});

	public reservationQuestionSettings = createFeatureIslandCategoryStore({
		title: "事前質問",
		description: "",
		isBasicSetup: false,
	});

	public reservationAdditionalFeeSettings = createFeatureIslandCategoryStore({
		title: "宿泊税など",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [this.base, this.reservationQuestionSettings, this.reservationAdditionalFeeSettings];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const hotelPolicyI18nCategoriesAndManagerStore = new HotelPolicyI18nCategoriesAndManagerStore();
